import { render, staticRenderFns } from "./ChatChannelPopup.vue?vue&type=template&id=5da7aa4b&scoped=true&"
import script from "./ChatChannelPopup.vue?vue&type=script&lang=ts&"
export * from "./ChatChannelPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChatChannelPopup.vue?vue&type=style&index=0&id=5da7aa4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da7aa4b",
  null
  
)

export default component.exports